import d from "./highrise1611.mjs";
import V from "./highrise653.mjs";
import j from "./highrise1326.mjs";
import y from "./highrise1311.mjs";
import c from "./highrise658.mjs";
import g from "./highrise1416.mjs";
import O from "./highrise648.mjs";
import C from "./highrise1421.mjs";
import M from "./highrise659.mjs";
import P from "./highrise1419.mjs";
import w from "./highrise661.mjs";
import x from "./highrise1422.mjs";
import D from "./highrise1424.mjs";
import b from "./highrise1613.mjs";
import F from "./highrise1436.mjs";
function U(t, p, o, v, A, l, f) {
  var i = b(t, o), e = b(p, o), s = f.get(e);
  if (s) {
    d(t, o, s);
    return;
  }
  var r = l ? l(i, e, o + "", t, p, f) : void 0, m = r === void 0;
  if (m) {
    var a = O(e), n = !a && M(e), u = !a && !n && D(e);
    r = e, a || n || u ? O(i) ? r = i : C(i) ? r = y(i) : n ? (m = !1, r = V(e, !0)) : u ? (m = !1, r = j(e, !0)) : r = [] : x(e) || g(e) ? (r = i, g(i) ? r = F(i) : (!w(i) || P(i)) && (r = c(e))) : m = !1;
  }
  m && (f.set(e, r), A(r, e, v, l, f), f.delete(e)), d(t, o, r);
}
export {
  U as default
};
